module.exports = __webpack_public_path__ + "img/2.15ef6a6e.jpg";